import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import {
  PayoffProtectedRoute,
  RootWrapper,
  SpinnerBlock,
  VOMProtectedRoute,
} from "./Utils/CustomComponent";
import { routeListConverter } from "./Utils";
import { useSelector } from "react-redux";

import DefaultManagementDetailsV3 from "./pages/LoanDetails";
import ScreenLogin from "./pages/Login";
import Register from "./pages/Register";
import Unauthorized from "./pages/Unauthorized";
import AddAccount from "./pages/AddAccount";
import OneRunNewReportBorrower from "./pages/Borrowers/Pages/ReportAndDocumentBorrower/OneRunNewReportBorrower";
import Dashboard from "./pages/Dashboard";
import DefaultManagement from "./pages/DefaultManagement";
import SubmitALoan from "./pages/SubmitALoan";
import ReportsNDocumentsNew from "./pages/ReportsNDocuments";
import Form from "./pages/Forms";
import Help from "./pages/Helps";
import AccountComp from "./pages/Account";
import SALForm from "./pages/SALForm/index";
import Conversations from "./components/Tools/Tools-Component/Conversations";
import AdminSettings from "./pages/AdminSettings";
import ManageAccount from "./pages/ManageAccount";
import EditProfile from "./pages/Profile/EditProfile";
import ScheduleReport from "./pages/ReportsNDocuments/Scheduled/ScheduleReport";
// import AllLoans from "./pages/Borrowers/Pages/AllLoans/AllLoans.js";
import BorrowersLoanDetails from "./pages/Borrowers/Pages/LoanDetailsBorrower/LoanDetailsBorrower";
import BorrowersScheduledPayments from "./pages/Borrowers/Pages/AllLoans/ScheduledPayments";
import ReportAndDocumentBorrower from "./pages/Borrowers/Pages/ReportAndDocumentBorrower/BorrowerReportAndDocument";
import RunNewReportBorrower from "./pages/Borrowers/Pages/ReportAndDocumentBorrower/RunNewReportBorrower";
// import SecureDocumentUpload from "./components/Tools/Tools-Component/SecureDocumentUpload";
// import MaturityOverrideTool from "./components/Tools/Tools-Component/MaturityOverrideTool";
import UserManagment from "./pages/UserManagment";
import CreateNewReport from "./pages/ReportsNDocuments/CreateNewReport";
import ChangePassword from "./pages/Profile/ChangePassword";
import ChangePasswordGate from "./pages/Profile/password/ChangePasswordGate";
import SecuritySettingsPage from "./pages/Profile/security/SecuritySettingsPage";
import Walkthrough from "./pages/Other/walkthrough";
import CustomerServicePortalSearch from "./pages/CustomerServicePortalSearch";
import AdminMenu from "./pages/AdminMenu/AdminMenu";
import BankAccountACHPayments from "./pages/Borrowers/BankAccountACHPayments";
import SameDayPayment from "./pages/Borrowers/Pages/ACHPayments/SameDayPayment";
import ChequeForm from "./components/ChequeForm";
import { TicketsHome } from "./pages/Tickets/TicketsHome";
import LenderInformation from "./pages/LenderInformation";
import LenderACHInformation from "./pages/LenderOnboarding/LenderACHInformation";
import PieChartDetails from "./pages/PieChartDetails/PieChartDetails";
import MeterDetails from "./pages/MeterDetails/MeterDetails";
import MasqueradeComponent from "./pages/Login/MasqueradeComponent";
import AdminSidebarMenuItems from "./pages/AdminSidebarMenuItems";
import AdminReportList from "./pages/AdminReportList";
import AdminCreateUser from "./pages/AdminMenu/AdminCreateUser";
import NewUserAdmissionForm from "./pages/NewUserAdmission";
import LenderAccountSetupForm from "./pages/LenderAccountSetupForm";
import LoanDocumentOrderForm from "./pages/BrokerForms/LoanDocumentOrderForm";
import LoanServicingOrderForm from "./pages/BrokerForms/LoanServicingOrderForm";
import DemandRequestForm from "./pages/BrokerForms/DemandRequestForm";
import BrokerForms from "./pages/BrokerForms/BrokerForms";
import VerificationOfMortgage from "./pages/BrokerForms/VerificationOfMortgage";
import LoanApplication from "./pages/BrokerForms/LoanApplication";
import StatementOfInformation from "./pages/BrokerForms/StatementOfInformation";
import SignatureAuthorization from "./pages/BrokerForms/SignatureAuthorization";
import Ticket from "./pages/Ticket";
import SingleTicketInfo from "./pages/Ticket/SingleTicketInfo";
import RoleMenu from "./pages/RoleMenu";
import RoleCreateUser from "./pages/RoleMenu/RoleCreateUser";
import DossDoc from "./pages/DossDoc";
import DossDocEditPage from "./pages/DossDoc/DossDocEditPage";
import LenderOnboarding from "./pages/LenderOnboarding";
import EnrollComp from "./pages/EnrollComp";
import Documentation from "./pages/Documentation";
import ChangeOfAddressForm from "./pages/BorrowerForms/ChangeOfAddressForm";
import OneTimeACHForm from "./pages/BorrowerForms/OneTimeACHForm";
import ACHRecurringForm from "./pages/BorrowerForms/ACHRecurringForm";
import DemandRequestFormBorrower from "./pages/BorrowerForms/DemandRequestFormBorrower";
import BorrowerForms from "./pages/BorrowerForms/BorrowerForms";
import IRSW9Form from "./pages/BorrowerForms/IRSW9Form";
import SignatureAuthorizationBorrower from "./pages/BorrowerForms/SignatureAuthorizationBorrower";
import DrawRequestFormBorr from "./pages/BorrowerForms/DrawRequestFormBorr";
import Borrower3rdParty from "./pages/BorrowerForms/Borrower3rdParty";
import BorrowerFinancialAssistance from "./pages/BorrowerForms/BorrowerFinancialAssistance";
import LenderForms from "./pages/LenderForms/LenderForms";
import ACHEnrollmentForm from "./pages/LenderForms/ACHEnrollmentForm";
import Lender3rdPartyAuth from "./pages/LenderForms/Lender3rdPartyAuth";
import IRSW9Lender from "./pages/LenderForms/IRSW9Lender";
import ChangeofAddressLender from "./pages/LenderForms/ChangeofAddressLender";
import LoanDocOrderLender from "./pages/LenderForms/LoanDocOrderLender";
import DrawRequestLender from "./pages/LenderForms/DrawRequestLender";
import VOMLender from "./pages/LenderForms/VOMLender";
import LoanServicingOrderLender from "./pages/LenderForms/LoanServicingOrderLender";
import AdditionalLenderForm from "./pages/BrokerForms/AdditionalLenderForm";
import LenderDemandRequestForm from "./pages/LenderForms/DemandRequestForm";
import LenderAdditionalLenderForm from "./pages/LenderForms/AdditionalLenderForm";
import LandingPage from "./pages/LandingPage";
import BorrowerLogin from "./pages/Login/BorrowerLogin";
import ForgotPassword from "./pages/ForgotPassword";
import ForgotPasswordGate from "./pages/ForgotPassword/ForgotPasswordGate";
import VerificationForm, { VOMNavbar } from "./pages/VerificationForm";
import DemandPayoff from "./pages/DemandPayoff";
import PayOffDetailScreen from "./pages/DemandPayoff/PayOffDetailScreen";
import CreatePayoff from "./pages/DemandPayoff/CreatePayoff";
// import LoanSearchTool from "./components/Tools/Tools-Component/LoanSearchTool";
import RunNewReport1 from "./pages/ReportsNDocuments/RunNewReport1";
import OneRunNewReport1 from "./pages/ReportsNDocuments/OneRunNewReport1";
import LoanOnbaording from "./pages/LoanOnboarding";
import NewSameDayPayment from "./pages/Borrowers/Pages/ACHPayments/NewSameDayPayment";
import NewBankAccountACHPayments from "./pages/Borrowers/NewBankAccountACHPayments";
import BorrowerDashboardTwo from "./pages/Borrowers/BorrowerDashboardTwo";
import ManageBanking from "./pages/Borrowers/BorrowerDashboardTwo/ManageBanking";
import AddBankAccount from "./pages/Borrowers/BorrowerDashboardTwo/ManageBanking/AddBankAccount";
import ApiDocumentation from "./pages/ApiDocumentation";
import LoanDetailsForDemo from "./pages/Borrowers/Pages/LoanDetailsBorrower/LoanDetailsBorrowerForDemo";
import OneTimeACH from "./pages/Borrowers/Pages/ACHPayments/OneTimeACH";
import OneTimePaymentForm from "./pages/Borrowers/Pages/ACHPayments/OneTimePaymentForm";
import VideoResources from "./components/Videos";
import UnsubscribeTicket from "./pages/UnsubscribeTicket";
import BorrowerLoansTable from "./pages/Borrowers/BorrowerDashboardTwo/BorrowerLoansTable";
import NSF from "./pages/NSF/Nsf";
import NSFOneTimePaymentForm from "./pages/NSF/NSFOneTimePaymentForm";
import PaymentSelection from "./pages/NSF/PaymentSelection";
import NSFNewSameDayPayment from "./pages/NSF/NSFNewSameDayPayment";
import NSFHistory from "./pages/NSF/NsfHistory";
// import NewLogin from "./pages/NewLogin";
// import CSPQuickAccountLookup from "./components/Tools/Tools-Component/CSPQuickAccountLookup";
import DossDocPromo from "./pages/DossDocPromo/index";
import PartnerFlowLogin from "./pages/Login/PartnerFlowLogin";
import TestDashboard from "./pages/Dashboard/TestDashboard";
import VOMGateway from "./pages/VerificationForm/VOMGateway";
import VOMDetails, {
  VOMDetailsForExternal,
} from "./pages/VerificationForm/VOMDetails";
import VOMMainPage from "./pages/VerificationForm/VOMMainPage";
import BorrowerVOMTable from "./pages/VerificationForm/BorrowerVOMTable";
import VOMStepperForm from "./pages/VerificationForm/VOMStepperForm";
import FeedbackThankYou from "./pages/ThankYou/ThankYouPage";
import CustomerSurveyForm from "./pages/CustomerSurveyForm";
import VOMRefundPage from "./pages/VerificationForm/VOMRefundPage";
import DuplicateVOM from "./pages/VerificationForm/DuplicateVOM";
import LenderDrawsDashbaord from "./pages/Borrowers/BorrowerDashboardTwo/Draws/LenderDrawsDashbaord";
import PayoffLogin from "./pages/PayoffThirdParty/PayoffLogin";
import RequestDetails from "./pages/DemandPayoff/RequestDetails";
import PayoffAuthRequests from "./pages/DemandPayoff/PayoffAuthRequests";
import ThirdPartyPayoffs from "./pages/DemandPayoff/ThirdPartyPayoffs";
import PayoffRequestForm from "./pages/PayoffThirdParty/PayoffRequestForm";
import UnauthorizeLink from "./pages/UnauthorizedPayoff/UnauthorizeLink";
import InvalidAuthorizationLink from "./pages/UnauthorizedPayoff/InvalidAuthorizationLink";

const RouterComp = () => {
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value,
  );
  const location = useLocation();
  const route = [
    {
      path: "/dashboard",
      element: <Dashboard />,
      name: "Dashboard",
    },
    {
      path: "/testing/chatbot",
      element: <TestDashboard />,
      name: "Dashboard",
    },
    {
      path: "/tickets",
      element: <TicketsHome />,
      name: "Tickets",
    },
    {
      path: "/profile",
      element: <Dashboard />,
      name: "Dashboard",
    },
    {
      path: "/pie-chart-details",
      element: <PieChartDetails />,
      name: "Dashboard",
    },
    {
      path: "/meter-details",
      element: <MeterDetails />,
      name: "Dashboard",
    },
    {
      path: "/loan-details/:loanId",
      element: <DefaultManagementDetailsV3 key={location.pathname} />,
      name: "Dashboard",
    },
    {
      path: "/loan-details/:loanId/:selectedtab",
      element: <DefaultManagementDetailsV3 />,
      name: "Dashboard",
    },

    {
      path: "/submit-a-loan",
      element: <SubmitALoan />,
      name: "Submit a Loan",
    },
    {
      path: "/lender-account-setup",
      element: <LenderAccountSetupForm />,
      name: "Submit a Loan",
    },
    {
      path: "/broker/forms",
      element: <BrokerForms />,
      name: "Submit a Loan",
    },
    {
      path: "/broker/loan-document-order-form",
      element: <LoanDocumentOrderForm />,
      name: "Submit a Loan",
    },
    {
      path: "/broker/additional-lender-form",
      element: <AdditionalLenderForm />,
      name: "Submit a Loan",
    },
    {
      path: "/lender/additional-lender-form",
      element: <LenderAdditionalLenderForm />,
      name: "Submit a Loan",
    },

    {
      path: "/broker/loan-servicing-order-form",
      element: <LoanServicingOrderForm />,
      name: "Submit a Loan",
    },
    {
      path: "/broker/demand-request-form",
      element: <DemandRequestForm />,
      name: "Submit a Loan",
    },
    {
      path: "/lender/demand-request-form",
      element: <LenderDemandRequestForm />,
      name: "Submit a Loan",
    },
    {
      path: "/broker/verification-of-mortgage",
      element: <VerificationOfMortgage />,
      name: "Submit a Loan",
    },
    {
      path: "/broker/1003-loan-application",
      element: <LoanApplication />,
      name: "Submit a Loan",
    },
    {
      path: "/broker/statement-of-information",
      element: <StatementOfInformation />,
      name: "Submit a Loan",
    },
    {
      path: "/broker/signature-authorization",
      element: <SignatureAuthorization />,
      name: "Submit a Loan",
    },
    {
      path: "/submit-a-loan/form",
      element: <SALForm />,
      name: "Submit a Loan",
    },

    {
      path: "/loan-onboarding",
      element: <LoanOnbaording />,
      name: "Submit a Loan",
    },

    {
      path: "/reports-and-documents",
      element: <ReportsNDocumentsNew />,
      name: "Reports & Document",
    },
    {
      path: "/reports-and-documents",
      element: <ReportsNDocumentsNew />,
      name: "Reports & Document",
    },
    // {
    //   path: "/run-new-report",
    //   element: <RunNewReport />,
    //   name: "Reports & Document",
    // },
    {
      path: "/run-new-report",
      element: <RunNewReport1 />,
      name: "Reports & Document",
    },
    // {
    //   path: "/run-new-report/:report",
    //   element: <OneRunNewReport />,
    //   name: "Reports & Document",
    // },
    {
      path: "/run-new-report/:report",
      element: <OneRunNewReport1 />,
      name: "Reports & Document",
    },
    {
      path: "/schedule-report",
      element: <ScheduleReport />,
      name: "Reports & Document",
    },
    {
      path: "/create-new-report",
      element: <CreateNewReport />,
      name: "Reports & Document",
    },

    {
      path: "/borrower-dashboard-two",
      element: <BorrowerDashboardTwo />,
      name: "Loan Details",
    },
    {
      path: "/nsf",
      element: <NSF />,
      name: "Loan Details",
    },
    {
      path: "/nsf-history",
      element: <NSFHistory />,
      name: "Loan Details",
    },
    {
      path: "/nsf/payment-selection",
      element: <PaymentSelection />,
      name: "Loan Details",
    },
    {
      path: "/nsf/one-time-payment",
      element: <NSFOneTimePaymentForm />,
      name: "Loan Details",
    },
    {
      path: "/nsf/same-day-payment",
      element: <NSFNewSameDayPayment />,
      name: "Loan Details",
    },
    // {
    //   path: "/borrower-dashboard",
    //   element: <BorrowerDashboard />,
    //   name: "Loan Details",
    // },

    // {
    //   path: "/loancards",
    //   element: <CardsPage />,
    //   name: "Loan Details",
    // },

    {
      path: "/loan-details-borrower",
      element: <BorrowersLoanDetails />,
      name: "Loan Details",
    },

    {
      path: "/loan-details-borrower1",
      element: <LoanDetailsForDemo />,
      name: "Loan Details",
    },

    {
      path: "/reports-and-documents",
      element: <ReportsNDocumentsNew />,
      name: "Loan Details",
    },

    {
      path: "/run-new-report",
      element: <RunNewReport1 />,
      name: "Loan Details",
    },

    {
      path: "/run-new-report/:report",
      element: <OneRunNewReport1 />,
      name: "Loan Details",
    },

    {
      path: "/schedule-report",
      element: <ScheduleReport />,
      name: "Loan Details",
    },

    {
      path: "/preview-check",
      element: <ChequeForm />,
      name: "Loan Details",
    },
    {
      path: "/ach-payment",
      element: <BankAccountACHPayments />,
      name: "Loan Details",
    },

    // {
    //   path: "/ach-payment/summary",
    //   element: <SummaryPage />,
    //   name: "Loan Details",
    // },

    {
      path: "/ach-paymentnew",
      element: <NewBankAccountACHPayments />,
      name: "Loan Details",
    },
    {
      path: "/same-day-payment",
      element: <NewSameDayPayment />,
      name: "Loan Details",
    },

    {
      path: "/one-time-payment",
      element: <OneTimeACH />,
      name: "Loan Details",
    },
    {
      path: "/one-time-payment/form",
      element: <OneTimePaymentForm />,
      name: "Loan Details",
    },

    // {
    //   path: "/interest-calculator",
    //   element: <InterestCalculator />,
    //   name: "Interest Calculator",
    // },
    {
      path: "/manage-banking",
      element: <ManageBanking />,
      name: "Loan Details",
    },
    {
      path: "/add-bank-account",
      element: <AddBankAccount />,
      name: "Loan Details",
    },
    {
      path: "/update-bank-account/:id",
      element: <AddBankAccount />,
      name: "Loan Details",
    },
    {
      path: "/api-documentation",
      element: <ApiDocumentation />,
      name: "Loan Details",
    },

    {
      path: "/meter-details",
      element: <MeterDetails />,
      name: "Loan Details",
    },

    {
      path: "/loan-details-borrower",
      element: <BorrowersLoanDetails />,
      name: "All Loans",
    },
    {
      path: "/loan-details-borrower/:loanId/:selectedtab",
      element: (
        <DefaultManagementDetailsV3
          isABorrower={true}
          comingFromInsuranceTab={true}
        />
      ),
      name: "Loan Details",
    },

    {
      path: "/reports-documents-borrower",
      element: <ReportAndDocumentBorrower />,
      name: "Reports & Documents",
    },
    {
      path: "/run-new-report-borrower",
      element: <RunNewReportBorrower />,
      name: "Reports & Documents",
    },
    {
      path: "/run-new-report-borrower/:id",
      element: <OneRunNewReportBorrower />,
      name: "Reports & Documents",
    },

    {
      path: "/scheduled-payments-borrower",
      element: <BorrowersScheduledPayments />,
      name: "Reports & Documents",
    },
    {
      path: "/default-management",
      element: <DefaultManagement />,
      name: "Default Management",
    },
    {
      path: "/docs",
      element: <Documentation />,
      name: "Support",
    },
    {
      path: "/support",
      element: <Ticket />,
      name: "Support",
    },
    {
      path: "/dossdoc",
      element: <DossDoc />,
      name: "Support",
    },
    {
      path: "/dossdoc/edit/:id/:applicationId",
      element: <DossDocEditPage />,
      name: "Support",
    },
    {
      path: "/support/:incidentId/:incidentNumber",
      element: <SingleTicketInfo />,
      name: "Support",
    },
    {
      path: "/role-menu",
      element: <RoleMenu />,
      // name: "Dashboard",
      name: "Support",
    },
    {
      path: "/role-menu/:type/:role_id",
      element: <RoleCreateUser />,
      // name: "Dashboard",
      name: "Support",
    },
    {
      path: "/role-menu/:type",
      element: <RoleCreateUser />,
      // name: "Dashboard",
      name: "Support",
    },
    {
      path: "/lender-onboard",
      element: <LenderOnboarding />,
      name: "Dashboard",
    },
    {
      path: "/lender-onboard/:type/:jsonId",
      element: <LenderACHInformation />,
      name: "Dashboard",
    },
    {
      path: "/lender-onboard/:type",
      element: <LenderACHInformation />,
      name: "Dashboard",
    },
    {
      path: "/admin-menu",
      element: <AdminMenu />,
      // name: "Dashboard",
      name: "Support",
    },
    {
      path: "/admin-menu/:type/:user_id",
      element: <AdminCreateUser />,
      // name: "Dashboard",
      name: "Support",
    },
    {
      path: "/admin-menu/:type",
      element: <AdminCreateUser />,
      // name: "Dashboard",
      name: "Support",
    },
    {
      path: "/menu-items-handler",
      element: <AdminSidebarMenuItems />,
      name: "Maturity Override Tool",
    },
    {
      path: "/admin-report-list",
      element: <AdminReportList />,
      name: "Maturity Override Tool",
    },
    {
      path: "/menu-items-handler",
      element: <AdminSidebarMenuItems />,
      name: "Maturity Override Tool",
    },
    {
      path: "/admin-report-list",
      element: <AdminReportList />,
      name: "Maturity Override Tool",
    },
    // {
    //   path: "/maturityOverrideTool",
    //   element: <MaturityOverrideTool />,
    //   name: "Maturity Override Tool",
    // },

    // {
    //   path: "/tools/secureDocumentUpload",
    //   element: <SecureDocumentUpload />,
    //   name: "Secure Document Upload",
    // },
    {
      path: "/lenderInformation",
      element: <LenderInformation />,
      name: "Dashboard",
    },
    {
      path: "/lender-ach-information",
      element: <LenderACHInformation />,
      name: "Dashboard",
    },
    // {
    //   path: "/tools",
    //   element: <Tools />,
    //   name: "Tools",
    //   child: [
    //     <Route
    //       path="/tools/cSPQuickAccountLookup"
    //       element={<CSPQuickAccountLookup />}
    //       key={"CSPQuickAccountLookup"}
    //     />,
    // {
    //   path: "/tools/cSPQuickAccountLookup",
    //   element: <CSPQuickAccountLookup />,
    //   name: "Dashboard",
    // },
    //  <Route
    //       path="/tools/cSPQuickAccountLookup"
    //       element={<CSPQuickAccountLookup />}
    //       key={"CSPQuickAccountLookup"}
    //     />,
    //     />,
    //     <Route
    //       path="/tools/clientValidation"
    //       element={<ClientValidation />}
    //       key={"clientValidation"}
    //     />,
    // {
    //   path: "/tools/loanSearchTool",
    //   element: <LoanSearchTool />,
    //   name: "Dashboard",
    // },
    //     <Route
    //       path="/tools/activeSameDayPaymentsTool"
    //       element={<ActiveSameDayPaymentsTool />}
    //       key={"activeSameDayPaymentsTool"}
    //     />,
    //     <Route
    //       path="/tools/paymentsCheque"
    //       element={<PaymentsCheque />}
    //       key={"paymentsCheque"}
    //     />,

    //     // <Route
    //     //   path="/tools/secureDocumentUpload"
    //     //   element={<SecureDocumentUpload />}
    //     //   key={"secureDocumentUpload"}
    //     // />,
    //     <Route
    //       path="/tools/recentClientUploads"
    //       element={<RecentClientUploads />}
    //       key={"recentClientUploads"}
    //     />,
    //     <Route
    //       path="/tools/bulkLoanCategoryAssignmentTool"
    //       element={<BulkLoanCategoryAssignmentTool />}
    //       key={"bulkLoanCategoryAssignmentTool"}
    //     />,
    //     // <Route
    //     //   path="/tools/maturityOverrideTool"
    //     //   element={<MaturityOverrideTool />}
    //     //   key={"support"}
    //     // />,
    //     <Route
    //       path="/tools/aPIUsage"
    //       element={<APIUsage />}
    //       key={"aPIUsage"}
    //     />,
    //     <Route
    //       path="/tools/userManagment"
    //       element={<UserManagment />}
    //       key={"userManagment"}
    //     />,
    //   ],
    // },
    // { path: "/tools", element: <Tools />, name: "Dashboard" },
    { path: "/conversations", element: <Conversations />, name: "Tools" },

    { path: "/forms", element: <Form />, name: "Forms" },
    { path: "/help", element: <Help />, name: "Help" },
    {
      path: "/admin-settings",
      element: <AdminSettings />,
      name: "Admin Settings",
    },
    // { path: "/allLoans", element: <AllLoans />, name: "All Loans" },
    {
      path: "/allLoans",
      element:
        selectedRole === "C" ? (
          <CustomerServicePortalSearch />
        ) : (
          <UserManagment />
        ),
      name: "All Loans",
    },
    {
      path: "/userManagment",
      element: <UserManagment />,
      name: "User Managment",
    },
    {
      path: "/account",
      element: <AccountComp />,
      name: "Account",
    },
    {
      path: "/add_account",
      element: <AddAccount />,
      name: "Account",
    },
    {
      path: "/manage-account",
      element: <ManageAccount />,
      name: "Account",
    },
    {
      path: "/manage-account/edit",
      element: <EditProfile />,
      name: "Account",
    },
    {
      path: "/manage-account/change-password",
      element: <ChangePasswordGate Legacy={ChangePassword} />,
      name: "Account",
    },
    {
      path: "/manage-account/security",
      element: <SecuritySettingsPage />,
      name: "Account",
    },

    /* Loan Servicing Forms for Borrowers */
    {
      path: "/borrower/forms",
      element: <BorrowerForms />,
      name: "Forms",
    },
    {
      path: "/borrower/change-of-address",
      element: <ChangeOfAddressForm />,
      name: "Forms",
    },
    {
      path: "/borrower/one-time-ach-debit",
      element: <OneTimeACHForm />,
      name: "Forms",
    },
    {
      path: "/borrower/ach-direct-debit",
      element: <ACHRecurringForm />,
      name: "Forms",
    },
    {
      path: "/borrower/demand-request-form",
      element: <DemandRequestFormBorrower />,
      name: "Forms",
    },
    {
      path: "/borrower/IRS-W9-form",
      element: <IRSW9Form />,
      name: "Forms",
    },
    {
      path: "/borrower/signature-authorization",
      element: <SignatureAuthorizationBorrower />,
      name: "Forms",
    },
    {
      path: "/borrower/draw-request-form",
      element: <DrawRequestFormBorr />,
      name: "Forms",
    },
    {
      path: "/borrower/3rd-party-auth",
      element: <Borrower3rdParty />,
      name: "Forms",
    },
    {
      path: "/borrower/financial-assistance",
      element: <BorrowerFinancialAssistance />,
      name: "Forms",
    },

    /* Loan Servicing Forms for Lender */
    {
      path: "/lender/forms",
      element: <LenderForms />,
      name: "Dashboard",
    },
    {
      path: "/lender/ach-enrollment-form",
      element: <ACHEnrollmentForm />,
      name: "Dashboard",
    },
    {
      path: "/lender/3rd-party-auth",
      element: <Lender3rdPartyAuth />,
      name: "Dashboard",
    },
    {
      path: "/lender/verification-of-mortgage",
      element: <VOMLender />,
      name: "Dashboard",
    },
    {
      path: "/lender/IRS-W9-form",
      element: <IRSW9Lender />,
      name: "Dashboard",
    },
    {
      path: "/lender/change-of-address",
      element: <ChangeofAddressLender />,
      name: "Dashboard",
    },
    {
      path: "/lender/loan-document-order-form",
      element: <LoanDocOrderLender />,
      name: "Dashboard",
    },
    {
      path: "/lender/draw-request-form",
      element: <DrawRequestLender />,
      name: "Dashboard",
    },
    {
      path: "/lender/loan-servicing-order-form",
      element: <LoanServicingOrderLender />,
      name: "Dashboard",
    },
    {
      path: "/demand-payoff",
      element: <DemandPayoff />,
      name: "Dashboard",
    },
    {
      path: "/demand-payoff-auth",
      element: <DemandPayoff />,
      name: "Loan Details",
    },
    {
      path: "/demand-payoff/:payoffId/:status",
      element: <PayOffDetailScreen />,
      name: "Dashboard",
    },
    {
      path: "/demand-payoff/create",
      element: <CreatePayoff />,
      name: "Dashboard",
    },

    {
      path: "/videos",
      element: <VideoResources />,
      name: "Video Resources",
    },
    {
      path: "/loans",
      element: <BorrowerLoansTable />,
      name: "Loan Details",
    },
    {
      path: "/dossdoc-promo",
      element: <DossDocPromo />,
      name: "DossDocs",
    },
    {
      path: "/voms/borrower",
      element: <BorrowerVOMTable />,
      name: "Loan Details",
    },
    {
      path: "/vom-details/:requestId",
      element: <VOMDetails />,
      name: "Loan Details",
    },
    {
      path: "/lender-draws-dashboard",
      element: <LenderDrawsDashbaord />,
      name: "Dashboard",
    },
    {
      path: "/lender-draws-dashboard/:id",
      element: <LenderDrawsDashbaord />,
      name: "Dashboard",
    },
     {
      path: "/payoff-authorization",
      element: <RequestDetails />,
      name: "Loan Details"
    },
    {
      path: "/payoff-auth-requests",
      element: <PayoffAuthRequests />,
      name: "Loan Details"
    }
  ];
  const routeState = routeListConverter(
    selectedRole,
    useSelector((state) => state.RS_Authentication.route),
    route,
  );
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const roles = useSelector((state) => state.RS_Authentication.roles)?.includes(
    "SLS Customer Servicing",
  );

  return (
    <Routes>
      <Route path="/borrower-onboarding" element={<BorrowerLogin />} />
      <Route path="/apps" element={<LandingPage />} />
      <Route path="/login" element={<ScreenLogin />} />
      <Route path="/partnerflow/login" element={<PartnerFlowLogin />} />
      {/* <Route path="/newlogin" element={<NewLogin />} /> */}
      <Route path="/reset-password" element={<ForgotPasswordGate Legacy={ForgotPassword} />} />
      <Route path="/enroll" element={<EnrollComp />} />
      <Route path="/new-user-admission" element={<NewUserAdmissionForm />} />
      <Route path="/walkthrough" element={<Walkthrough />} />
      <Route path="/register/*" element={<Register />} />
      <Route path="/masquerade" element={<MasqueradeComponent />} />
      <Route path="unauthorized" element={<Unauthorized />} />
      <Route
        path="/feedback/:ticketId/:ticketNumber"
        element={<CustomerSurveyForm />}
      />
      <Route path="/thankyou" element={<FeedbackThankYou />} />
      <Route
        path="/verification-form/:email"
        element={
          <VOMProtectedRoute>
            <VOMStepperForm />
          </VOMProtectedRoute>
        }
      />
      <Route path="/vom-gateway" element={<VOMGateway />} />
      <Route path="/vom-gateway/borrower" element={<VOMGateway />} />
      <Route path="/payoff-gateway" element={<PayoffLogin />} />
      <Route
        path="/payoff-gateway-authorize"
        element={
          <PayoffLogin
            title="Payoff Authorization"
            text="Welcome! Enter the email address registered with your loan to access and authorize your payoff request."
          />
        }
      />
      <Route
        path="/vom/:email"
        element={
          <VOMProtectedRoute>
            <VOMMainPage />
          </VOMProtectedRoute>
        }
      />
      <Route
        path="/payoff-requests"
        element={
          <PayoffProtectedRoute>
            <ThirdPartyPayoffs />
          </PayoffProtectedRoute>
        }
      />
      <Route
        path="/authorize-requests"
        element={
          <PayoffProtectedRoute>
            <ThirdPartyPayoffs />
          </PayoffProtectedRoute>
        }
      />
      <Route
        path="/payoff-request-form"
        element={
          <PayoffProtectedRoute>
            <PayoffRequestForm />
          </PayoffProtectedRoute>
        }
      />
      {/* <Route path="/vom/borrower/:email" element={<VOMMainPage />} /> */}
      <Route
        path="/vom-details/:requestId/:email"
        element={
          <VOMProtectedRoute>
            <VOMDetailsForExternal />
          </VOMProtectedRoute>
        }
      />
      <Route
        path="/vom/refund/:email"
        element={
          <VOMProtectedRoute>
            <VOMRefundPage />
          </VOMProtectedRoute>
        }
      />
      <Route
        path="/vom/duplicate/:email"
        element={
          <VOMProtectedRoute>
            <DuplicateVOM />
          </VOMProtectedRoute>
        }
      />

      <Route
        path="/payoff/invalid"
        element={
          <PayoffProtectedRoute>
            <DuplicateVOM
              title={<span className="text-error">Invalid Email!</span>}
              body={
                <p className="text-muted">
                  The email address you entered does not match the email address
                  registered to this loan.
                </p>
              }
              feeNote={false}
              source="error"
            />
          </PayoffProtectedRoute>
        }
      />

      <Route
        path="/payoff/duplicate"
        element={
          <PayoffProtectedRoute>
            <DuplicateVOM
              title="Payoff Already Exists!"
              body={
                <p className="text-muted">
                  A Payoff Request has already been generated for this specific
                  Property or Loan within our records.
                </p>
              }
              feeNote={false}
            />
          </PayoffProtectedRoute>
        }
      />

      <Route
        path="/payoff-request/details"
        element={
          <PayoffProtectedRoute>
            <VOMNavbar title="Request Payoff" />
            <RequestDetails />
          </PayoffProtectedRoute>
        }
      />

      <Route
        path="/payoff-borrower-authorization"
        element={
          <PayoffProtectedRoute>
            <VOMNavbar title="Payoff Authorization" />
            <RequestDetails />
          </PayoffProtectedRoute>
        }
      />
      {/* <Route path="/vom-details/external/:requestId/:email" element={<VOMDetailsForExternal />} /> */}
      <Route
        path="/unsubscribe/:ticketId/:ticketNumber"
        element={<UnsubscribeTicket />}
      />
      {accountOptions?.length || roles ? (
        <Route path="/" element={<RootWrapper />}>
          <Route
            path="/"
            element={<Navigate to={routeState?.[0]?.path || "/add_account"} />}
          />
          <Route path="/add_account" element={<AddAccount />} />
          {routeState?.length &&
            routeState?.map((data, index) =>
              data?.child ? (
                <Route
                  key={index}
                  path={data.path}
                  element={
                    <React.Suspense
                      fallback={
                        <div style={{ marginTop: "130px" }}>
                          <SpinnerBlock />
                        </div>
                      }
                    >
                      {data.element}
                    </React.Suspense>
                  }
                >
                  {data.child}
                </Route>
              ) : (
                <Route
                  key={index}
                  path={data.path}
                  element={
                    <React.Suspense
                      fallback={
                        <div style={{ marginTop: "130px" }}>
                          <SpinnerBlock />
                        </div>
                      }
                    >
                      {data.element}
                    </React.Suspense>
                  }
                />
              ),
            )}
        </Route>
      ) : (
        <Route path="/add_account" element={<AddAccount />} />
      )}
      <Route path="*" element={<Unauthorized />} />
      <Route path="*" element={<Unauthorized />} />
      <Route path="/admin-menu" element={<AdminMenu />} />
      <Route path="/same-day-payment" element={<SameDayPayment />} />
      <Route path="/unauthorize-payoff-access" element={<UnauthorizeLink />} />
      <Route path="/invalid-payoff-link" element={<InvalidAuthorizationLink />} />
    </Routes>
  );
};

export default RouterComp;
